import React, { useState } from "react";
import styled from "styled-components";
import TextColumn from "./TextColumn";
import Paywall from "components/pages/article/Paywall";
import SuccessMessage from "components/shared/alerts/SuccessMessage";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";

const TextEssayContainer = styled.div.attrs({
  className: "w-screen flex justify-center relative",
})``;

const TextEssay = ({
  router,
  story,
  paywalled,
  sharedStoryLinkExists,
}: {
  story: any;
  paywalled: boolean;
  sharedStoryLinkExists: boolean;
} & WithRouterProps) => {
  const [fractionScrolled, setFractionScrolled] = useState(0);
  const [signupSuccessMessageVisible, setSignupSuccessMessageVisible] =
    React.useState(true);
  const justSignedUp = router.query.justSignedUp;

  return (
    <>
      <SuccessMessage
        show={justSignedUp && signupSuccessMessageVisible}
        text="You are now subscribed to The Juggernaut."
        onClickClose={() => setSignupSuccessMessageVisible(false)}
      />
      <TextEssayContainer>
        <TextColumn
          paywalled={paywalled}
          story={story}
          onChangeFractionScrolled={(fractionScrolled) =>
            setFractionScrolled(fractionScrolled)
          }
          sharedStoryLinkExists={sharedStoryLinkExists}
        />
        {paywalled && <Paywall story={story} />}
      </TextEssayContainer>
    </>
  );
};

export default withRouter(TextEssay);
